import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

  transform(itemList: any, searchKeyword: string) {
    const filteredList = [];
    if (!itemList) {
      return [];
    }
    if (!searchKeyword) {
      return itemList;
    }
    if (itemList.length > 0) {
      searchKeyword = searchKeyword.toLowerCase();
      itemList.forEach(item => {
        // Object.values(item) => gives the list of all the property values of the 'item' object
        const propValueList = Object.values(item);
        for ( let i = 0; i < propValueList.length; i++) {
          if (propValueList[i]) {
            if (propValueList[i].toString().toLowerCase().indexOf(searchKeyword) > -1) {
              filteredList.push(item);
              break;
            }
          }
        }
      });
    }
    return filteredList;
  }

}
